import * as React from 'react';
import { IMoeV2960ContainerProps } from './moe-v2-960-container.props.autogenerated';

export interface IMoeV2960ContainerViewProps extends IMoeV2960ContainerProps<{}> {
    // Removed children, now using slots directly
}

class MoeV2960Container extends React.PureComponent<IMoeV2960ContainerProps<{}>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default MoeV2960Container;
